/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProcessExcelFileCommandResult } from '../../models/process-excel-file-command-result';

export interface ApiProjectItemProcessExcelFilePost$Params {
      body?: {
'ExcelFile'?: Blob;
'ProjectId'?: string;
}
}

export function apiProjectItemProcessExcelFilePost(http: HttpClient, rootUrl: string, params?: ApiProjectItemProcessExcelFilePost$Params, context?: HttpContext): Observable<StrictHttpResponse<ProcessExcelFileCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectItemProcessExcelFilePost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ProcessExcelFileCommandResult>;
    })
  );
}

apiProjectItemProcessExcelFilePost.PATH = '/api/ProjectItem/ProcessExcelFile';
